import { Dispatch, SetStateAction } from "react"
import ReactPlayer from "react-player"
import { CustomImage, useIsDesktop } from "ui"
import { getUmbracoMediaUrl } from "utils/getUmbracoMediaUrl"

export const isVideo = (url?: string): boolean => {
  if (!url) return false
  return (
    url.includes(".mp4") || url.includes("youtube") || url.includes("youtu.be")
  )
}

type Props = {
  source: string
  playing: boolean
  setPlaying: Dispatch<SetStateAction<boolean>>
  volume: boolean
  setVolume: Dispatch<SetStateAction<boolean>>
  alt?: string
}

const ReactPlayerComponent = ({
  source,
  playing,
  volume,
  alt,
  setPlaying,
}: Props) => {
  const isMediaVideo = isVideo(source)
  const isDesktop = useIsDesktop()
  if (!source) {
    return null
  }
  return isMediaVideo ? (
    <ReactPlayer
      controls={true}
      muted={!volume}
      loop
      playing={playing}
      url={getUmbracoMediaUrl(source)}
      width={"100%"}
      height={isDesktop ? "100%" : "340px"}
      playsinline={true}
      onPause={() => setPlaying(false)}
      onEnded={() => setPlaying(false)}
      onPlay={() => setPlaying(true)}
      config={{
        file: {
          attributes: {
            autoPlay: true,
            playsInline: true,
            muted: true,
            preload: "auto",
            style: { objectFit: "cover", width: "100%", height: "100%" },
          },
          forceVideo: true,
        },
      }}
      style={{ display: "flex", position: "absolute", inset: 0 }}
    />
  ) : (
    <CustomImage
      src={getUmbracoMediaUrl(source)}
      alt={alt || ""}
      fill
      style={{ objectFit: "cover" }}
      priority
    />
  )
}

export default ReactPlayerComponent
